import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import FormatCurrency from 'components/Common/FormatCurrency'

export interface CharterDurationToggleOption {
  label: string
  value: number
  displayPrice?: number
  buttonStartIcon?: React.ReactNode
  disabled?: boolean
}

interface Props {
  options: ReadonlyArray<CharterDurationToggleOption>
  selectedValue: number
  onChange: (value: number) => void
  unavailableMessage?: string
  isMemberPrice?: boolean
  pricesLoading?: boolean
}

function CharterDurationToggleControl(props: Props) {
  const {
    options,
    selectedValue,
    onChange,
    unavailableMessage,
    isMemberPrice,
    pricesLoading,
  } = props

  if (options.length < 2) {
    return null
  }

  const [optionA, optionB] = options

  const handleOptionChange = (value: string) => {
    const parsedValue = parseInt(value, 10)
    if (Number.isNaN(parsedValue)) {
      return
    }
    onChange(parsedValue)
  }

  const optionBSubtitle = (() => {
    if (pricesLoading) return undefined
    if (!optionB.disabled && optionB.displayPrice) {
      const price = <FormatCurrency format="roundedDollar" value={optionB.displayPrice} />
      if (isMemberPrice) {
        return <FormattedMessage
          id="rsX5mZsMr_0llfMi5bmP"
          defaultMessage="From {price}"
          description="Member price with From prefix for charter duration toggle option"
          values={{ price }}
        />
      }
      return price
    }
    if (optionB.disabled) return unavailableMessage
  })()

  return (
    <SegmentedOptionsGroup inputsName="charter-duration" onValueChange={handleOptionChange}>
      <SegmentedOption
        value={String(optionA.value)}
        title={optionA.label}
        subtitle={(() => {
          if (pricesLoading || !optionA.displayPrice) return undefined
          const price = <FormatCurrency format="roundedDollar" value={optionA.displayPrice} />
          if (isMemberPrice) {
            return <FormattedMessage
              id="rsX5mZsMr_0llfMi5bmP"
              defaultMessage="From {price}"
              description="Member price with From prefix for charter duration toggle option"
              values={{ price }}
            />
          }
          return price
        })()}
        disabled={optionA.disabled}
        icon={optionA.buttonStartIcon}
        defaultChecked={selectedValue === optionA.value}
      />
      <SegmentedOption
        value={String(optionB.value)}
        title={optionB.label}
        subtitle={optionBSubtitle}
        disabled={optionB.disabled}
        icon={optionB.buttonStartIcon}
        defaultChecked={selectedValue === optionB.value}
      />
    </SegmentedOptionsGroup>
  )
}

export default CharterDurationToggleControl
